export const empresaConstants = {
    TRAER_EMPRESAS: 'TRAER_EMPRESAS',
    AGREGAR_EMPRESA: 'AGREGAR_EMPRESA',
    ACT_EMPRESA: 'ACT_EMPRESA'
};
